import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdsProvider } from "@/components/AdSlot";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import TablePage from "@/pages/TablePage";
import FixturesPage from "@/pages/FixturesPage";
import MatchPage from "@/pages/MatchPage";
import ClubsPage from "@/pages/ClubsPage";
import ClubProfilePage from "@/pages/ClubProfilePage";
import PlayerPage from "@/pages/PlayerPage";
import FeedPage from "@/pages/FeedPage";
import { SofascoreStandings } from "@/components/SofascoreStandings";
import StoryPage from "@/pages/StoryPage";
import { FantasyHub } from "@/pages/FantasyHub";
import FantasyPick from "@/pages/FantasyPick";
import FantasyChat from "@/pages/FantasyChat";
import ForumPage from "@/pages/ForumPage";
import { BoardPage, ThreadPage } from "@/pages/ForumThreadPages";
import AdvertisePage from "@/pages/AdvertisePage";
import { PrivacyPolicy, CookiePolicy, TermsPage, AboutPage, DisclaimerPage, ChildrensPolicy, ContactPage } from "@/pages/PolicyPages";
import { LoginPage, SignupPage } from "@/pages/AuthPages";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import FeedbackPage from "@/pages/FeedbackPage";
import InstallPage from "@/pages/InstallPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import NotFound, { NoIndex } from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <AdsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/table" element={<TablePage />} />
              <Route path="/fixtures" element={<FixturesPage />} />
              <Route path="/match/:id" element={<MatchPage />} />
              <Route path="/clubs" element={<ClubsPage />} />
              <Route path="/clubs/:slug" element={<ClubProfilePage />} />
              <Route path="/players/:id" element={<PlayerPage />} />
              <Route path="/news" element={<FeedPage type="news" />} />
              <Route path="/news/:slug" element={<StoryPage type="news" />} />
              <Route path="/articles" element={<NotFound />} />
              <Route path="/articles/:slug" element={<NotFound />} />
              <Route path="/updates" element={<NotFound />} />
              <Route path="/updates/:slug" element={<NotFound />} />
              <Route path="/timeline" element={<NotFound />} />
              <Route path="/table/live" element={<div className="max-w-3xl mx-auto"><h1 className="font-head font-black text-2xl mb-4">Live standings (Sofascore)</h1><SofascoreStandings /></div>} />
              <Route path="/fantasy" element={<><NoIndex /><FantasyHub /></>} />
              <Route path="/fantasy/pick" element={<><NoIndex /><FantasyPick /></>} />
              <Route path="/fantasy/chat" element={<><NoIndex /><FantasyChat /></>} />
              <Route path="/forum" element={<ForumPage />} />
              <Route path="/forum/:board" element={<BoardPage />} />
              <Route path="/forum/:board/:thread" element={<ThreadPage />} />
              <Route path="/advertise" element={<AdvertisePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms-and-conditions" element={<TermsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/childrens-policy" element={<ChildrensPolicy />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/install" element={<InstallPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AdsProvider>
    </AuthProvider>
  );
}

export default App;
